module.exports = __webpack_public_path__ + "34951e6b46251f0237e1cfa571b68714.MP3";